export default {
    namespaced: true,
    state: {
      list: [],
      index: 0
    },
    getters: {
      list(state){
        return state.list;
      }
    },
    actions: {

    },
    mutations: {
    
    }
  }
